"use strict";
import { useMemo } from "react";
import { checkWalletDelegation } from "uniswap/src/data/apiClients/tradingApi/TradingApiClient";
import { createTradingApiDelegationRepository } from "uniswap/src/features/smartWallet/delegation/createTradingApiDelegationRepository";
import { createDelegationService } from "uniswap/src/features/smartWallet/delegation/delegation";
import { useUpdateDelegatedState } from "uniswap/src/features/smartWallet/delegation/hooks/useUpdateDelegateState";
import { getLogger } from "utilities/src/logger/logger";
export function useDelegationService() {
  const updateDelegatedState = useUpdateDelegatedState();
  return useMemo(() => {
    return createDelegationService({
      delegationRepository: createTradingApiDelegationRepository({
        tradingApiClient: { checkWalletDelegation },
        logger: getLogger()
      }),
      onDelegationDetected: (payload) => {
        updateDelegatedState({ chainId: String(payload.chainId), address: payload.address });
      }
    });
  }, [updateDelegatedState]);
}
